import React from 'react';

export default function KonfirmasiBerangkat() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Konfirmasi Berangkat</h1>
      <p className="text-gray-500">Halaman Konfirmasi Berangkat</p>
    </div>
  );
}
